module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-plus-43327894.svg";